<template>
  <div>
    <multiselect 
      v-model="$store.state.valueDepartment"
      :options="options"
      @input="onChange"
      placeholder="Selecciona Departamento"
      label="text"
      track-by="text"
      :show-labels="false"
    ></multiselect>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import axios from "axios";
  import { mapMutations } from 'vuex'
  import config from '../../../helpers/config';
  import api from "../../../api/index";

  export default {
    props: ['valuex'],
    mounted() {
      this.getDepartaments()
    },
    data () {
      return {
      value: [],
      options: []
      }
    },
    methods: {
      ...mapMutations([
        'filterExperiences'
      ]),
      reset(){
        api.getExperiences();
      },
      onChange(event){
        //localStorage.setItem("depart_id", event.value)
        this.value = event && event.value ? event.value: false
        console.log(this.value)
        this.$store.state.departamento = this.value
        this.filterExperiences({
          isObject: false,
          isArray: false,
          filter: 'locationId',
          id: this.value
        })
      },
      getDepartaments(){
        axios.get(`${config.urlApi}/locationDepartments`, {})
          .then(response => {
              response.data.forEach(element => {
                this.options.push({
                  value: element.locationDepartmentId,
                  text: element.department
                })
            });
        })
        .catch(function (error) {
         ////console.log(error)
        })
      },
    },
    components: {
      Multiselect
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect{
  width: 100% !important;
}
</style>
